"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from "react";
import { useIXEvent } from "../interactions";
import { cj, useClickOut, KEY_CODES } from "../utils";
import { Link } from "./Basic";
import { NavbarContext } from "./Navbar";
function getLinksList(root) {
    return root.querySelectorAll(".w-dropdown-list .w-dropdown-link");
}
const DropdownContext = /*#__PURE__*/ React.createContext({
    root: undefined,
    isOpen: false,
    toggleOpen: ()=>undefined,
    setFocusedLink: ()=>undefined,
    hover: false
});
const INITIAL_DROPDOWN_STATE = {
    isOpen: false,
    openingCount: 0
};
export const DropdownWrapper = /*#__PURE__*/ React.forwardRef(function DropdownWrapper(_param, ref) {
    var { delay, hover } = _param, props = _object_without_properties(_param, [
        "delay",
        "hover"
    ]);
    const root = React.useRef(null);
    const [{ isOpen }, setIsOpen] = React.useState(INITIAL_DROPDOWN_STATE);
    const [focusedLink, setFocusedLink] = React.useState(-1);
    const closeTimeoutRef = React.useRef();
    React.useImperativeHandle(ref, ()=>root.current);
    React.useEffect(()=>{
        return ()=>{
            clearTimeout(closeTimeoutRef.current);
        };
    }, []);
    const toggleOpen = React.useCallback(()=>{
        clearTimeout(closeTimeoutRef.current);
        setFocusedLink(-1);
        setIsOpen((_param)=>{
            var { openingCount } = _param, rest = _object_without_properties(_param, [
                "openingCount"
            ]);
            return _object_spread_props(_object_spread({}, rest), {
                openingCount: openingCount + 1
            });
        });
        if (delay > 0 && isOpen) {
            closeTimeoutRef.current = setTimeout(()=>{
                setIsOpen(({ openingCount })=>({
                        openingCount,
                        isOpen: openingCount % 2 === 1
                    }));
            }, delay);
        } else {
            setIsOpen(({ openingCount })=>({
                    openingCount,
                    isOpen: openingCount % 2 === 1
                }));
        }
    }, [
        hover,
        isOpen,
        delay
    ]);
    const closeDropdown = React.useCallback(()=>setIsOpen(INITIAL_DROPDOWN_STATE), [
        setIsOpen
    ]);
    useClickOut(root, closeDropdown);
    useIXEvent(root.current, isOpen);
    React.useEffect(()=>{
        if (root.current) {
            var _links_;
            const links = getLinksList(root.current);
            (_links_ = links[focusedLink !== null && focusedLink !== void 0 ? focusedLink : 0]) === null || _links_ === void 0 ? void 0 : _links_.focus();
        }
    }, [
        focusedLink
    ]);
    return /*#__PURE__*/ React.createElement(DropdownContext.Provider, {
        value: {
            root,
            isOpen,
            toggleOpen,
            setFocusedLink,
            hover
        }
    }, /*#__PURE__*/ React.createElement(Dropdown, _object_spread({}, props)));
});
function Dropdown(_param) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    const { root, setFocusedLink, hover, toggleOpen } = React.useContext(DropdownContext);
    const { isOpen: isNavbarOpen } = React.useContext(NavbarContext);
    const handleFocus = (e)=>{
        const linkList = root.current ? Array.from(getLinksList(root.current)) : [];
        const linkAmount = linkList.length;
        switch(e.key){
            case KEY_CODES.ARROW_LEFT:
            case KEY_CODES.ARROW_UP:
                {
                    e.preventDefault();
                    setFocusedLink((prev)=>Math.max(prev - 1, 0));
                    break;
                }
            case KEY_CODES.ARROW_RIGHT:
            case KEY_CODES.ARROW_DOWN:
                {
                    e.preventDefault();
                    setFocusedLink((prev)=>Math.min(prev + 1, linkAmount - 1));
                    break;
                }
            case KEY_CODES.HOME:
                {
                    e.preventDefault();
                    setFocusedLink(0);
                    break;
                }
            case KEY_CODES.END:
                {
                    e.preventDefault();
                    setFocusedLink(linkAmount - 1);
                    break;
                }
            case KEY_CODES.TAB:
                {
                    setTimeout(()=>{
                        setFocusedLink(linkList.findIndex((link)=>link === document.activeElement));
                    }, 0);
                    break;
                }
            case KEY_CODES.SPACE:
                {
                    e.preventDefault();
                    break;
                }
            default:
                {
                    return;
                }
        }
    };
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({}, props), {
        ref: root,
        onKeyDown: handleFocus,
        onMouseEnter: ()=>{
            if (hover) {
                toggleOpen();
            }
        },
        onMouseLeave: ()=>{
            if (hover) {
                toggleOpen();
            }
        },
        className: cj(className, "w-dropdown", isNavbarOpen && "w--nav-dropdown-open")
    }));
}
export const DropdownToggle = /*#__PURE__*/ React.forwardRef(function DropdownToggle(_param, ref) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    const { isOpen, toggleOpen, hover } = React.useContext(DropdownContext);
    const { isOpen: isNavbarOpen } = React.useContext(NavbarContext);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({}, props), {
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        className: cj(className, "w-dropdown-toggle", isNavbarOpen && "w--nav-dropdown-toggle-open"),
        onClick: ()=>{
            if (!hover) toggleOpen();
        },
        onKeyDown: (e)=>{
            if (e.key === KEY_CODES.ENTER || e.key === KEY_CODES.SPACE) {
                toggleOpen();
                e.stopPropagation();
                return e.preventDefault();
            }
        },
        role: "button",
        tabIndex: 0,
        ref
    }));
});
export const DropdownList = /*#__PURE__*/ React.forwardRef(function DropdownList(_param, ref) {
    var { tag = "nav", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    const { isOpen } = React.useContext(DropdownContext);
    const { isOpen: isNavbarOpen } = React.useContext(NavbarContext);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({}, props), {
        className: cj(className, "w-dropdown-list", isOpen && "w--open", isNavbarOpen && "w--nav-dropdown-list-open"),
        ref
    }));
});
export const DropdownLink = /*#__PURE__*/ React.forwardRef(function DropdownLink(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    const { isOpen: isNavbarOpen } = React.useContext(NavbarContext);
    return /*#__PURE__*/ React.createElement(Link, _object_spread_props(_object_spread({}, props), {
        className: cj(className, "w-dropdown-link", isNavbarOpen && "w--nav-link-open"),
        tabIndex: 0,
        ref
    }));
});
